export enum GoogleTagManagerEvents {
  Authenticated = "authenticated"
}
